import { isMissingUsRegionContext } from '@cx-modules/odds-grid-api-service/region-context';

import type { OddsGridProps } from '../types';

export class MissingRegionContextError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'MissingRegionContextError';
  }
}

type RegionValidationProps = Pick<OddsGridProps, 'countryCode' | 'subdivision' | 'noDataAvailableFallbackText'>;

export const useRegionValidation = ({
  countryCode,
  noDataAvailableFallbackText,
  subdivision,
}: RegionValidationProps) => {
  if (isMissingUsRegionContext({ countryCode, subdivision })) {
    throw new MissingRegionContextError(noDataAvailableFallbackText || 'No odds available in your region');
  }
};
